// extracted by mini-css-extract-plugin
module.exports = {"field":"PhoneNumberInput_field__10hoA","label":"PhoneNumberInput_label__LgqSU","tooltip":"PhoneNumberInput_tooltip__26yuL"};